import request from '@/utils/request'

export function listProd(query) {
  return request({
    url: '/api/group/listProd',
    method: 'post',
    params: query
  })
}

export function listUsedProd(data) {
  return request({
    url: '/api/group/listUsedProd',
    method: 'post',
    data
  })
}

